import { getApiClient } from '@/api-client/api-client';

export const getNotifications = async () => {
  return getApiClient()
    .getNotifications()
    .then((res) => res.data);
};

export const markNotificationAsRead = async (notificationIds: number[]) => {
  return getApiClient()
    .markAsRead({ markAsReadRequest: { notificationIds } })
    .then((res) => res.data);
};
